<template>
  <div class="project-changeUpgrade-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="search-hd">
            <el-form :inline="true" @submit.native.prevent>
              <el-form-item v-if="model.data.bodyNum||model.data.modemSn">
                <p>{{ $t('dms_device_changeUpgrade_dialog.xygjbb') }}：{{fwinfo}}</p>
              </el-form-item>
              <!-- 搜索栏 -->
              <el-form-item style="float: right" >
                <custom-select
                  code="tcp_module"
                  v-model="componentValue"
                  width="100%"
                  @change="onComponentCodeChange"
                  :placeholder="$t('dms_device_changeUpgrade_dialog.xia_fa_mo_kuai')"
                ></custom-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="table-bd">
            <custom-table
              ref="table"
              type="radio"
              v-model="selectRow"
              :data="resourceList"
              :loading="isLoading"
              tableCode="firmware_upgrade"
              selectableKey="selectableKey"
              :slots="[ 'isMatchFwVersion']"
              @filter="filterChange"
              @sort="sortChange"
              height="500px"
            >
            <template v-slot:isMatchFwVersion="scope">
            <div :class="scope.row.isMatchFwVersion === 1 ? 'green' : 'red'">
              {{ getDicValue('isynergy_cloud_approval_result', scope.row.isMatchFwVersion) }}
            </div>
          </template>
        </custom-table>
          </div>
          <div class="table-page">
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" :disabled="Object.keys(this.selectRow).length === 0" @click="saveChoose">{{ $t('Common.com_confirm') }}</el-button>
      </div>

    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  components: { },
  mixins: [dialogMixins],
  data() {
    return {
      isLoading: false,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        bodyNum: '',
        modemSn: '',
        componentCode: '',
      },
      componentCode: '',
      componentValue: '',
      totalRows: null,
      selectRow: {},
      fwList: [],
      resourceList: [],
    };
  },
  computed: {
    fwinfo() {

      return (this.model.data.bodyNum || this.model.data.modemSn) && this.fwList.map(item => (item.fwVersion !== '' ? `${item.componentName}  ${item.fwVersion}` : '')).filter(item => item !== '').join(',');

    },

  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.formSearch.bodyNum = this.model.data.bodyNum;
    this.formSearch.modemSn = this.model.data.modemSn;
    // this.formSearch.componentCode = this.model.data.componentCode;
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.onComponentCodeChange();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 设备固件详情
    getFirmwareInfo: function () {
      this.$getJSON(apis.deviceStructureFwList, { ...this.formSearch, componentCode: this.componentCode }).then((res) => {
        this.fwList = res.data || [];
      });
    },
    // modem固件详情
    getModemFirmwareInfo: function () {
      this.$getJSON(apis.DeviceFwList, { ...this.formSearch, componentCode: this.componentCode }).then((res) => {
        this.fwList = res.data || [];
      });
    },
    // 获取关联列表
    getTableList: function () {
      this.isLoading = true;
      this.$getJSON(apis.resourcePageForDevice, { ...this.formSearch, componentCode: this.componentValue }).then((res) => {
        this.isLoading = false;
        // this.resourceList = res.data ? res.data.list : [];
        const list = res.data ? res.data.list : [];
        list.forEach((item) => {
          item.selectableKey = !!item.isMatchFwVersion;
        });
        this.resourceList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 下发模块
    onComponentCodeChange: function (item) {
      this.componentCode = item ? item.code : '';
      this.onPageChange({ page: 1 });
      if (this.model.data.bodyNum) {
        this.getFirmwareInfo();
      } else if (this.model.data.modemSn) {
        this.getModemFirmwareInfo();
      }

    },

    // 保存新增
    saveChoose: function () {
      const params = {};
      params.bodyNum = this.model.data.bodyNum;
      params.modemSn = this.model.data.modemSn;
      params.resourceId = this.selectRow.resourceId;

      this.$postJSON(apis.DeviceResumeFirmwareUpgrade,
        params
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.$emit('success');
        this.closeDialog();
      });


    },
  },
};
</script>

<style lang="scss">
.project-changeUpgrade-dialog {
  .green {
    color: #67c23a;
  }

  .red {
    color: #f56c6c;
  }
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
